import { FC } from 'react';

import {
  BarLoader,
  BounceLoader,
  ClipLoader,
  PuffLoader,
  ScaleLoader,
} from 'react-spinners';

import { TColorProp, useTheme } from 'styled-components';

import { getThemeColor } from '~/common/utils/get-theme-color';

interface ILoaderProps {
  type?: 'puff' | 'bounce' | 'clip' | 'scale' | 'bar';
  size?: number;
  color?: TColorProp;
}
export const Loader: FC<ILoaderProps> = ({
  type = 'puff',
  size = 20,
  color = 'neutral.800',
}) => {
  const theme = useTheme();

  const loaders = {
    puff: PuffLoader,
    bounce: BounceLoader,
    clip: ClipLoader,
    scale: ScaleLoader,
    bar: BarLoader,
  };

  const CustomLoader = loaders[type];
  return <CustomLoader size={size} color={getThemeColor(theme, color)} />;
};
